import * as React from 'react';
// import styles from './index.less';
import * as AHooks from 'ahooks';

interface FUpdateVersionProps {
  className?: string;
  style?: React.CSSProperties;

  onClick?(): void;
}

function FUpdateVersion({ className, ...props }: FUpdateVersionProps) {

  AHooks.useMount(() => {
    const styleTags = document.querySelectorAll('style');
    for (let i = 0; i < styleTags.length; i++) {
      const styleTag = styleTags[i];
      const innerHTML = styleTag.innerHTML;
      if (innerHTML.includes('font_1522685_olm1021d5l.css')) {
        // 如果包含指定字符串，将该style标签从DOM中移除
        styleTag.parentNode?.removeChild(styleTag);
      }
    }
  });

  return (<i className={['freelog', 'fl-icon-gengxinbanben', className].join(' ')} {...props} />);
}

export default FUpdateVersion;
